// DiscountForm.js
import React, { useCallback, useEffect, useState } from "react";
import DiscountForm from "../discountForm/discountForm.js";
import DisplayHeading from "../displayHeading/displayHeading.js";
import * as helpers from "../../utils/utils.js";
import "./priceDisplay.css";
import { useQueries } from "react-query";
import { useUnits } from "../../hooks/useUnits.js";
import { usePrices } from "../../hooks/usePrices.js";
import { cache } from "react";

const PriceDisplay = ({
  hideDiscountForm,
  totals,
  selectedSlots,
  appliedDiscount,
  addManualDiscount,
  removeSlot,
  hideEdit,
}) => {
  const { retrieveUnitById } = useUnits();
  const { retrievePriceById } = usePrices();

  const [showEdit, setShowEdit] = useState(false);

  const toggleShowEdit = () => {
    setShowEdit(!showEdit);
  }

  const unitQueries = useQueries(
    selectedSlots.map(({ unitId }) => ({
      queryKey: ["unit", unitId],
      queryFn: () => retrieveUnitById(unitId), // You implement this
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60, // 1 hour cache
      refetchOnWindowFocus: false, // prevent re-fetch on tab switch
    }))
  );
  
  const priceQueries = useQueries(
    selectedSlots.map(({ priceId }) => ({
      queryKey: ["price", priceId],
      queryFn: () => retrievePriceById(priceId), // You implement this
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60, // 1 hour cache
      refetchOnWindowFocus: false, // prevent re-fetch on tab switch
    }))
  );
  
  // Later, match them up
  const getUnit = (unitId) =>
    unitQueries.find((q) => q.data?.id === unitId)?.data;
  
  const getPrice = (priceId) =>
    priceQueries.find((q) => q.data?.id === priceId)?.data;

  return (
    <div className="price-display-container main-border">
      <DisplayHeading doSomething={toggleShowEdit} buttonName={hideEdit ? null : "Edit"} title={"Cart"} />

      {(appliedDiscount?.length > 0 || selectedSlots?.length > 0) && (
        <div className="container cost-details">
          <table className="table selections-table">
            <tbody>
              {selectedSlots
                .sort((a, b) => a.date - b.date)
                .map(({ id, unitId, priceId, date }) => {
                  const priceInfo = getPrice(priceId);
                  const unitInfo = getUnit(unitId);

                  if (!priceInfo || !unitInfo) {
                    return (
                      <tr key={id}>
                        <td colSpan="2">Loading slot info...</td>
                      </tr>
                    );
                  }

                  const dateInt = parseInt(date);
                  const { hours, minutes } = helpers.minutesToHours(
                    priceInfo.duration,
                  );
                  const formattedDate = new Date(dateInt).toLocaleDateString(
                    "en-US",
                    {
                      weekday: "long",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      timeZone: "UTC",
                    },
                  );

                  const startTime = `${helpers.formatTime(priceInfo.startTime.hours, priceInfo.startTime.minutes)}`;
                  const endTime = `${helpers.formatTime(hours + priceInfo.startTime.hours, minutes + priceInfo.startTime.minutes)}`;

                  return (
                    <tr key={id}>
                      <td className="unit-description">
                        <div className="remove-btn-container">{showEdit && <button className="btn remove-btn" onClick={() => removeSlot({slotId: id})}>X</button>}</div>
                        <img
                          className="price-image"
                          src={unitInfo.picture}
                          alt={unitInfo.name}
                          width="fit"
                        />
                        <div>
                          <span className="bold-text">{unitInfo.name}</span> <br /> {formattedDate} <br /> {startTime + " - " + endTime}
                        </div>
                      </td>
                      <td className="price-item">${priceInfo.price}</td>
                    </tr>
                  );
                })}

                {appliedDiscount.amount > 0 &&  (
                  <tr key={appliedDiscount.code}>
                    <td>PROMO: {appliedDiscount.code}</td>
                    <td className="price-item">-${appliedDiscount.amount}</td>
                  </tr>
                )}

            </tbody>
          </table>

          {!hideDiscountForm && <DiscountForm
            addManualDiscount={addManualDiscount}
          />}

          <table className="table price-table">
            <tbody>
              <tr className="cost-display-contianer">
                <td>
                  <div>Total Cost</div>
                  {/* <div className="cost-note">*Additional Fees Apply: Fuel</div> */}
                </td>
                <td className="price-item" id="total-price">${totals.total}</td>
              </tr>
              <tr className="deposit-display-contianer">
                <td className="indent">Amount Due on Arrival</td>
                <td className="price-item">
                  ${totals.total - totals.deposit}
                </td>
              </tr>
              <tr className="deposit-display-contianer">
                <td className="indent">Deposit Due Today</td>
                <td className="price-item">${totals.deposit}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PriceDisplay;
